import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { GetAutoPaySequenceService } from 'src/app/shared/services/api/get-auto-pay-sequence.service';

@Component({
  selector: 'app-auto-redeem-dialog',
  templateUrl: './auto-redeem-dialog.component.html',
  styleUrls: ['./auto-redeem-dialog.component.scss']
})
export class AutoRedeemDialogComponent {
  selectedMethods: string[] = [];
  currentSelection: any;
  autopayOptions: any;
  defaultMethod: any;
  isAutoPay: boolean;
  skipFirstStep: boolean;
  skipConfirmation: boolean;

  systemError: boolean = false;
  buttonLoading: boolean = false;
  currentStep: any = 0;

  @Output() autopayResult = new EventEmitter<any>();

  constructor(
    public dialogRef: MatDialogRef<AutoRedeemDialogComponent>,
    public router: Router,
    public route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private getAutoPaySequence: GetAutoPaySequenceService
  ) {
    this.currentSelection = data?.currentSelection;
    this.autopayOptions = data?.autopayOptions;
    this.defaultMethod = data?.defaultMethod;
    this.isAutoPay = data?.isAutoPay;
    this.skipFirstStep = data?.skipFirstStep;
    this.skipConfirmation = data.skipConfirmation;


    // Ensure that we push the selected methods in the correct order (autopayOptions object is always in the right order)
    for (let i = 0; i < this.autopayOptions.length; i++) {
      if (this.autopayOptions[i].checked == true) {
        if (this.autopayOptions[i].key == 'rewards') { this.selectedMethods.push('rewards'); }
        else if (this.autopayOptions[i].key == 'cash') { this.selectedMethods.push('cash'); }
        else if (this.autopayOptions[i].key == 'default') { this.selectedMethods.push('default'); }
      }
    }

      // Skip to the final step if skipFirstStep is true
     /*   if (this.skipFirstStep) {
        this.currentStep = 1;
      } */

  }
  
  ngOnInit() {
    this.autopayResult.emit(false);
  }

  // confirmRedeem() {
  //   this.buttonLoading = true;
  //   this.getAutoPaySequence.setAutoPay(this.currentSelection).subscribe(
  //     data => {
  //       this.buttonLoading = false;
  //       if (data.success) {
  //         this.currentStep = 1;
  //         this.autopayResult.emit(true);
  //       } else {
  //         this.systemError = true;
  //         this.autopayResult.emit(false);
  //       }
  //     }, error => {
  //       this.buttonLoading = false;
  //       this.systemError = true;
  //       this.autopayResult.emit(false);
  //     }
  //   );
  // }

confirmRedeem() {
  this.buttonLoading = true;
  this.systemError = false;

  let finalPayload: any;
  let apiServiceMethod: (data: any) => Observable<any>;
  
  // 1. Determine Payload and API Service Method
  if (this.data.isPPI) {
    // 1A. PPI: Use the specialized DWSetAutoRedeem payload structure.
    
    // The currentSelection was correctly built in the parent component to contain DWSetAutoRedeem fields.
    // We only need to filter out any extraneous keys if they exist in currentSelection.
    
    // We are using the correct DWSetAutoRedeem fields built in the parent:
    finalPayload = {
      walletID: this.currentSelection.walletID,
      customerID: this.currentSelection.customerID,
      autoRedeem: this.currentSelection.autoRedeem,
      rewardsOption: this.currentSelection.rewardsOption,
      cashOption: this.currentSelection.cashOption,
      paymentPreference: this.currentSelection.paymentPreference,
      optedBy: this.currentSelection.optedBy,
      sessionID: this.currentSelection.sessionID,
    };
    
    // Set the API service method to the new, specific PPI Auto Redeem endpoint
    apiServiceMethod = this.getAutoPaySequence.setPpiAutoRedeem.bind(this.getAutoPaySequence);

  } else {
    // 1B. ONL: Use the generic DWSetAutoPay payload (which includes all sequence/policy fields).
    
    // Use the payload exactly as prepared in the parent component for ONL.
    finalPayload = this.currentSelection; 
    
    // Set the API service method to the standard ONL Auto Pay endpoint
    apiServiceMethod = this.getAutoPaySequence.setAutoPay.bind(this.getAutoPaySequence);
  }

  // 2. Define the Observable (This is done correctly without execution)
  const apiCall$ = apiServiceMethod(finalPayload);

  // 3. Execute the API call by subscribing (Only one subscription executes the API once)
  apiCall$.subscribe({
    next: (data) => {
      this.buttonLoading = false;
      
      // Check for success condition (assuming 'success: true' OR 'statusCode: 0' for PPI success)
      if (data?.success === true || data?.statusCode === '200' || data?.statusCode === 0) {
        this.currentStep = 1; // Show 'Update Confirmed' screen
        this.autopayResult.emit(true); // Signal success (true) to the parent component
      } else {
        // Handle API success=false or other failure status
        console.error('API call reported failure:', finalPayload, 'Response:', data);
        this.systemError = true;
        this.autopayResult.emit(false); // Signal failure (false) to the parent
      }
    },
    error: (error) => {
      // Handle network or observable errors
      console.error('Network/Subscription error during confirmRedeem:', error);
      this.buttonLoading = false;
      this.systemError = true;
      this.autopayResult.emit(false); // Signal failure (false)
    }
  });
}

  close() {
    this.autopayResult.emit('cancel');
    this.dialogRef.close();
}

  thankYou() {
    this.dialogRef.close();
  }
}
